/**
 * @generated SignedSource<<99fd8a0e2d4a23219a54c92adfd9dd3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AggregateLevel = "YEAR" | "MONTH" | "DAY" | "%future added value";
export type FinancialAggregatedNumber = "actualRevenue" | "billableActualTimeAndExpenses" | "nonBillableActualTimeAndExpenses" | "allActualTimeAndExpenses" | "actualCost" | "actualProfit" | "actualRevenueProfit" | "actualMargin" | "actualRevenueMargin" | "plannedRevenue" | "billablePlannedTimeAndExpenses" | "nonBillablePlannedTimeAndExpenses" | "allPlannedTimeAndExpenses" | "plannedCost" | "plannedProfit" | "plannedRevenueProfit" | "plannedMargin" | "plannedRevenueMargin" | "remainingRevenue" | "billableForecastTimeAndExpensesToComplete" | "nonBillableForecastTimeAndExpensesToComplete" | "allForecastTimeAndExpensesToComplete" | "remainingCost" | "forecastCostToComplete" | "remainingProfit" | "forecastProfitToComplete" | "forecastRevenueProfitToComplete" | "remainingMargin" | "forecastMarginToComplete" | "forecastRevenueMarginToComplete" | "forecastRevenue" | "billableTotalTimeAndExpensesAtCompletion" | "nonBillableTotalTimeAndExpensesAtCompletion" | "allTotalTimeAndExpensesAtCompletion" | "forecastCost" | "totalCostAtCompletion" | "forecastProfit" | "totalProfitAtCompletion" | "totalRevenueProfitAtCompletion" | "forecastMargin" | "totalMarginAtCompletion" | "totalRevenueMarginAtCompletion" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineCost" | "baselineProfit" | "baselineMargin" | "baselineVsActualRevenue" | "baselineVsActualRevenueRecognition" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualProfit" | "baselineVsActualMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueMargin" | "baselineVsForecastRevenue" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsAllActualValueOfService" | "baselineVsAllProjectedValueOfService" | "estimatedVsAllActualValueOfService" | "estimatedVsAllProjectedValueOfService" | "baselineVsForecastCost" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsForecastProfit" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineMinutes" | "planVsActualRevenue" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsActualCost" | "planVsActualProfit" | "planVsActualMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueMargin" | "planVsForecastRevenue" | "planVsForecastCost" | "planVsForecastProfit" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "recognitionLockedRevenue" | "registeredMinutes" | "billableActualMinutes" | "nonBillableActualMinutes" | "remainingMinutes" | "forecastTimeToComplete" | "forecastMinutes" | "totalTimeAtCompletion" | "scopeApprovedMinutes" | "scopeTotalMinutes" | "allocationMinutes" | "invoiced" | "paid" | "accruedDeferred" | "baselineVsRegisteredMinutes" | "baselineVsForecastMinutes" | "baselineVsTotalTimeAtCompletion" | "registeredVsScopeApprovedMinutes" | "scopeApprovedVsRegisteredMinutes" | "forecastVsScopeApprovedMinutes" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "billableTime" | "recognitionPercentage" | "recognitionAmount" | "surplus" | "surplusPercentage" | "estimatedCost" | "recognitionProfit" | "recognitionProfitPercentage" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionForecastRevenue" | "totalRevenueRecognition" | "estimatedCostPercentage" | "expenseRevenuePercentage" | "expenseCostPercentage" | "recognitionOpenRevenue" | "actualOpenRevenue" | "actualLockedRevenue" | "totalActualRevenueRecognition" | "forecastOpenRevenueToComplete" | "forecastLockedRevenueToComplete" | "totalForecastRevenueToComplete" | "suggestedRevenue" | "suggestedRevenuePercentage" | "suggestedProfit" | "suggestedProfitPercentage" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type RevenueRecognitionLoader_Query$variables = {
  projectId: string;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  aggregateLevel: AggregateLevel;
  aggregates: ReadonlyArray<FinancialAggregatedNumber | null>;
  searchQuery?: TaskSearchQueryType | null;
  expenseAggregates: ReadonlyArray<FinancialAggregatedNumber | null>;
  expenseSearchQuery?: TaskSearchQueryType | null;
  hasExpenses: boolean;
};
export type RevenueRecognitionLoader_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"RevenueRecognitionLoader_viewer">;
  } | null;
};
export type RevenueRecognitionLoader_Query = {
  variables: RevenueRecognitionLoader_Query$variables;
  response: RevenueRecognitionLoader_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregateLevel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregates"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expenseAggregates"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expenseSearchQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasExpenses"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "revenue_recognition_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"revenue_recognition_loader\")"
},
v15 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v16 = {
  "kind": "Variable",
  "name": "aggregates",
  "variableName": "aggregates"
},
v17 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v18 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v19 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v20 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v21 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v22 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v23 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  (v24/*: any*/)
],
v26 = {
  "kind": "Literal",
  "name": "addAccumulatedNumbers",
  "value": true
},
v27 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionAmount",
  "storageKey": null
},
v29 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "expenseSearchQuery"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RevenueRecognitionLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "args": [
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "kind": "Variable",
                "name": "expenseAggregates",
                "variableName": "expenseAggregates"
              },
              {
                "kind": "Variable",
                "name": "expenseSearchQuery",
                "variableName": "expenseSearchQuery"
              },
              {
                "kind": "Variable",
                "name": "hasExpenses",
                "variableName": "hasExpenses"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "RevenueRecognitionLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v12/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "RevenueRecognitionLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": (v25/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v26/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v27/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "aggregatedFinancialNumbers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v27/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfitPercentage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "hasExpenses",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "workAggregatedFinancialNumbers",
                    "args": [
                      (v26/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v27/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "aggregatedFinancialNumbers",
                    "storageKey": null
                  },
                  {
                    "alias": "workFinancialNumbers",
                    "args": [
                      (v27/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "concreteType": "FinancialNumbers",
                    "kind": "LinkedField",
                    "name": "financialNumbers",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "expenseAggregatedFinancialNumbers",
                    "args": [
                      (v26/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "aggregates",
                        "variableName": "expenseAggregates"
                      },
                      (v27/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v29/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "aggregatedFinancialNumbers",
                    "storageKey": null
                  },
                  {
                    "alias": "expenseFinancialNumbers",
                    "args": [
                      (v27/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v29/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "concreteType": "FinancialNumbers",
                    "kind": "LinkedField",
                    "name": "financialNumbers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billableTotalTimeAndExpensesAtCompletion",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "allTotalTimeAndExpensesAtCompletion",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a6c00e988f8bda413e16876726ecdd9",
    "id": null,
    "metadata": {},
    "name": "RevenueRecognitionLoader_Query",
    "operationKind": "query",
    "text": "query RevenueRecognitionLoader_Query(\n  $projectId: ID!\n  $startYear: Int\n  $startMonth: Int\n  $startDay: Int\n  $endYear: Int\n  $endMonth: Int\n  $endDay: Int\n  $aggregateLevel: AggregateLevel!\n  $aggregates: [FinancialAggregatedNumber]!\n  $searchQuery: TaskSearchQueryType\n  $expenseAggregates: [FinancialAggregatedNumber]!\n  $expenseSearchQuery: TaskSearchQueryType\n  $hasExpenses: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"revenue_recognition_loader\")\n    ...RevenueRecognitionLoader_viewer_1FfX2a\n    id\n  }\n}\n\nfragment RevenueRecognitionLoader_viewer_1FfX2a on Viewer {\n  id\n  company {\n    currency\n    id\n  }\n  project(internalId: $projectId) {\n    rateCard {\n      currency\n      id\n    }\n    aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true)\n    financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true) {\n      recognitionAmount\n      estimatedCost\n      recognitionProfit\n      recognitionProfitPercentage\n    }\n    workAggregatedFinancialNumbers: aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true, searchQuery: $searchQuery) @include(if: $hasExpenses)\n    workFinancialNumbers: financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, searchQuery: $searchQuery) @include(if: $hasExpenses) {\n      recognitionAmount\n    }\n    expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $expenseAggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true, searchQuery: $expenseSearchQuery) @include(if: $hasExpenses)\n    expenseFinancialNumbers: financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, searchQuery: $expenseSearchQuery) @include(if: $hasExpenses) {\n      billableTotalTimeAndExpensesAtCompletion\n      allTotalTimeAndExpensesAtCompletion\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a17519c1265d7e45f255c9e2344d8288";

export default node;
